import { FirstMessageType } from '@/shared/types/analytics';

/**
 * Maps the first-message-type session filter (proactive/reactive) to the
 * `is_proactive` Boolean query arg used by the shared session queries.
 * An unset selection contributes nothing, leaving sessions unfiltered.
 */
export const mapFirstMessageTypeFilter = (
  firstMessageType: FirstMessageType | null | undefined
): { isProactive?: boolean } => {
  if (firstMessageType === 'proactive') {
    return { isProactive: true };
  }
  if (firstMessageType === 'reactive') {
    return { isProactive: false };
  }
  return {};
};
